import Model from './BaseModel';
import Market from './Market.js';
// TODO: IS THIS NEEDED?

export default class MarketTypeGroup extends Model {
	resourceName() {
		return 'market_type_groups';
	}

	fields() {
		return ['is_primary', 'name', 'order'];
	}

	relationships() {
		return {
			markets: new Market()
		};
	}
}
